import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import CartContext from '../../context/CartContext'
import GamingVideoItem from '../GamingVideoItem'
import Header from '../Header'
import SideBar from '../SideBar'
import {
  HomeContainer,
  HomeSideContainer,
  SearchedVideoContainer,
  VideosContainer,
  ProductsLoaderContainer,
  NotFoundContainer,
  Image,
  Heading,
  Desc,
  NavLink,
  Retry,
  HomeStickyContainer,
} from './styledComponents'

const apiStatusConstant = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class GamingRoute extends Component {
  state = {
    apiStatus: apiStatusConstant.initial,
    searchedVideos: [],
  }

  componentDidMount() {
    this.getSuggestionVideo()
  }

  getSuggestionVideo = async () => {
    this.setState({apiStatus: apiStatusConstant.inProgress})
    const jwtToken = Cookies.get('jwt_token')
    const apiUrl = 'https://apis.ccbp.in/videos/gaming'
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }

    try {
      const response = await fetch(apiUrl, options)
      if (response.ok) {
        const fetchedData = await response.json()
        const updatedData = fetchedData.videos.map(each => ({
          id: each.id,
          title: each.title,
          thumbnailUrl: each.thumbnail_url,
          publishedAt: each.published_at,
          viewCount: each.view_count,
        }))
        this.setState({
          searchedVideos: updatedData,
          apiStatus: apiStatusConstant.success,
        })
      } else {
        this.setState({apiStatus: apiStatusConstant.failure})
      }
    } catch (error) {
      this.setState({apiStatus: apiStatusConstant.failure})
    }
  }

  renderLoadingView = () => (
    <ProductsLoaderContainer data-testid="loader">
      <Loader type="ThreeDots" color="#0b69ff" height={50} width={50} />
    </ProductsLoaderContainer>
  )

  renderFailureView = () => (
    <NotFoundContainer>
      <Image
        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png"
        alt="failure view"
      />
      <Heading>Oops! Something Went Wrong</Heading>
      <Desc>
        We are having some trouble completing your request. Please try again.
      </Desc>
      <NavLink to="#">
        <Retry onClick={this.getSuggestionVideo}>Retry</Retry>
      </NavLink>
    </NotFoundContainer>
  )

renderGamingVideos = () => {
  const {searchedVideos} = this.state

  return (
    <CartContext.Consumer>
      {value => {
        const {isDarkTheme} = value
        const bgColor = isDarkTheme ? '#231f20' : '#ffffff' // Set background color based on theme

        return (
          <SearchedVideoContainer data-testid="gaming" bgColor={bgColor}>
            <h1 style={{color: isDarkTheme ? '#f9f9f9' : '#1e293b'}}>Gaming</h1> {/* Adjust heading color */}
            <VideosContainer>
              {searchedVideos.map(each => (
                <GamingVideoItem key={each.id} details={each} />
              ))}
            </VideosContainer>
          </SearchedVideoContainer>
        )
      }}
    </CartContext.Consumer>
  )
}

  renderAllVideos = () => {
    const {apiStatus} = this.state

    switch (apiStatus) {
      case apiStatusConstant.success:
        return this.renderGamingVideos()
      case apiStatusConstant.inProgress:
        return this.renderLoadingView()
      case apiStatusConstant.failure:
        return this.renderFailureView()
      default:
        return null
    }
  }

  render() {
    return (
      <CartContext.Consumer>
        {value => {
          const {isDarkTheme} = value
          const bgColor = isDarkTheme ? '#0f0f0f' : '#f9f9f9'

          return (
            <div data-testid="home">
              <Header />
              <HomeContainer data-testid="home" bgColor={bgColor}>
                <HomeStickyContainer>
                  <SideBar />
                </HomeStickyContainer>
                <HomeSideContainer bgColor={bgColor}>
                  {this.renderAllVideos()}
                </HomeSideContainer>
              </HomeContainer>
            </div>
          )
        }}
      </CartContext.Consumer>
    )
  }
}

export default GamingRoute
